import { polygonArea } from "../../polygonArea";
import type { PolygonAreaM2 } from "./types";

export const polygonAreaM2: PolygonAreaM2 = ({ points, metersPerPdfPoint }) => {
  if (metersPerPdfPoint <= 0) return null;
  return polygonArea(points) * metersPerPdfPoint * metersPerPdfPoint;
};
